/* Habib Alruh, theme behaviour (vanilla). Replaces the React/Framer/Zustand
   client logic. All hooks are data-* attributes emitted by the Liquid sections;
   see CONVENTIONS.md. */
(function () {
  'use strict';
  var root = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ============================ Money formatting ============================ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(num, dec, thg, dsep) {
      thg = thg === undefined ? ',' : thg;
      dsep = dsep === undefined ? '.' : dsep;
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(dec);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thg);
      var centsPart = parts[1] ? dsep + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = defaultTo(cents, 0, ' ', ''); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ============================ Scroll reveal ============================ */
  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh && r.bottom > 0;
  }
  function initReveals() {
    var els = $$('.reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) {
      // Reveal above-the-fold content (e.g. the hero) immediately instead of
      // waiting on an async IO callback; observe the rest for scroll reveal.
      if (inView(el)) el.classList.add('is-visible');
      else io.observe(el);
    });
    // Failsafe: after load, reveal anything still hidden but on-screen.
    window.addEventListener('load', function () {
      setTimeout(function () {
        $$('.reveal:not(.is-visible)').forEach(function (el) { if (inView(el)) el.classList.add('is-visible'); });
      }, 200);
    });
  }

  /* ============================ Mobile menu ============================ */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    function open() {
      menu.classList.remove('opacity-0', 'pointer-events-none');
      menu.classList.add('opacity-100');
      document.body.classList.add('no-scroll');
    }
    function close() {
      menu.classList.add('opacity-0', 'pointer-events-none');
      menu.classList.remove('opacity-100');
      document.body.classList.remove('no-scroll');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) open();
      else if (e.target.closest('[data-menu-close]')) close();
    });
  }

  /* ============================ Cart drawer + AJAX ============================ */
  function initCart() {
    var rootEl = $('[data-cart-root]');
    var drawer = $('[data-cart-drawer]');
    var overlay = $('[data-cart-overlay]');
    if (!rootEl || !drawer || !overlay) return;
    var moneyFormat = rootEl.getAttribute('data-money-format') || '${{amount}}';
    var threshold = parseInt(rootEl.getAttribute('data-threshold'), 10) || 20000;

    function openCart() {
      overlay.classList.remove('hidden');
      requestAnimationFrame(function () { overlay.classList.add('opacity-100'); overlay.classList.remove('opacity-0'); });
      drawer.classList.remove('translate-x-full');
      drawer.classList.add('translate-x-0');
      document.body.classList.add('no-scroll');
    }
    function closeCart() {
      overlay.classList.add('opacity-0'); overlay.classList.remove('opacity-100');
      drawer.classList.add('translate-x-full'); drawer.classList.remove('translate-x-0');
      document.body.classList.remove('no-scroll');
      setTimeout(function () { overlay.classList.add('hidden'); }, 300);
    }

    function updateCount(count) {
      $$('[data-cart-count]').forEach(function (b) {
        b.textContent = count;
        b.classList.toggle('hidden', count === 0);
      });
    }

    function icon(name) {
      var paths = {
        trash: '<path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"/>',
        minus: '<path d="M5 12h14"/>',
        plus: '<path d="M12 5v14M5 12h14"/>',
        bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>'
      };
      return '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || '') + '</svg>';
    }

    function renderEmpty() {
      return '<div class="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">' +
        '<svg class="icon text-taupe" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p class="font-display text-xl">Your cart is empty</p>' +
        '<p class="text-sm text-taupe">Discover a scent worth carrying.</p>' +
        '<button type="button" data-cart-close class="inline-flex items-center justify-center gap-2 rounded-button font-body font-medium uppercase tracking-[0.14em] transition-colors duration-300 bg-ink text-white hover:bg-[#222] h-11 px-6 text-sm">Continue Shopping</button>' +
        '</div>';
    }

    function renderContents(cart) {
      var subtotal = cart.total_price;

      var items = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + escapeHtml(item.product_title) + '" class="h-full w-full object-cover">' : '';
        var variantLine = (item.product_has_only_default_variant) ? '' : '<p class="text-xs text-taupe">' + escapeHtml(item.variant_title || '') + '</p>';
        var props = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (k) {
            if (k.charAt(0) !== '_' && item.properties[k]) props += '<p class="text-xs text-taupe">' + escapeHtml(k) + ': ' + escapeHtml(item.properties[k]) + '</p>';
          });
        }
        return '<div class="flex gap-4 py-4" data-cart-item data-key="' + item.key + '">' +
          '<div class="h-20 w-20 shrink-0 overflow-hidden rounded-card bg-ink">' + img + '</div>' +
          '<div class="flex flex-1 flex-col"><div class="flex justify-between"><div>' +
          '<h3 class="font-display text-base">' + escapeHtml(item.product_title) + '</h3>' + variantLine + props +
          '</div><button data-cart-remove data-key="' + item.key + '" aria-label="Remove item" class="text-taupe transition hover:text-[#b4453a]">' + icon('trash') + '</button></div>' +
          '<div class="mt-auto flex items-center justify-between"><div class="flex items-center rounded-button border border-black/15">' +
          '<button data-cart-minus data-key="' + item.key + '" aria-label="Decrease quantity" class="grid h-8 w-8 place-items-center">' + icon('minus') + '</button>' +
          '<span class="w-8 text-center text-sm" data-cart-qty>' + item.quantity + '</span>' +
          '<button data-cart-plus data-key="' + item.key + '" aria-label="Increase quantity" class="grid h-8 w-8 place-items-center">' + icon('plus') + '</button>' +
          '</div><span class="font-semibold">' + formatMoney(item.final_line_price, moneyFormat) + '</span></div></div></div>';
      }).join('');

      return '<div class="flex h-full flex-col">' +
        '<div data-cart-items class="flex-1 divide-y divide-black/5 overflow-y-auto px-6 pt-2">' + items + '</div>' +
        '<div class="border-t border-black/10 px-6 py-5">' +
        '<div data-combo-nudge></div>' +
        '<div class="flex justify-between text-sm"><span class="text-taupe">Subtotal</span><span class="font-semibold" data-cart-subtotal>' + formatMoney(subtotal, moneyFormat) + '</span></div>' +
        '<div class="mt-1 flex justify-between text-sm"><span class="text-taupe">Delivery</span><span>Calculated at checkout</span></div>' +
        '<div class="mt-3 flex justify-between border-t border-black/10 pt-3 font-display text-lg"><span>Total</span><span data-cart-total>' + formatMoney(subtotal, moneyFormat) + '</span></div>' +
        '<form action="/cart" method="post"><button type="submit" name="checkout" class="mt-4 inline-flex h-14 w-full items-center justify-center gap-2 rounded-button bg-gold px-9 text-sm font-medium uppercase tracking-[0.14em] text-ink transition-colors duration-300 hover:bg-[#b8993f]">Proceed to Checkout</button></form>' +
        '</div></div>';
    }

    // Combo nudge ("add 2 more, get 3 for AED 99"). Config comes from snippets/combo-offer.liquid;
    // the discount itself is applied by Shopify, this only tells the shopper how close they are.
    var comboEl = $('[data-combo-offer]');
    var combo = null;
    try { combo = comboEl ? JSON.parse(comboEl.textContent) : null; } catch (err) { combo = null; }

    function comboCount(cart) {
      return cart.items.reduce(function (n, item) {
        return combo.ids.indexOf(item.variant_id) > -1 ? n + item.quantity : n;
      }, 0);
    }

    function renderCombo(count) {
      var left = (3 - (count % 3)) % 3;
      var filled = count > 0 && left === 0 ? 3 : count % 3;
      var item = combo.name + ' ' + combo.size;
      var title, sub;
      if (count === 0) {
        title = 'Any 3 ' + item + ' for <span class="text-gold">' + combo.price + '</span>';
        sub = 'Plus a chance to win ' + combo.prize;
      } else if (left) {
        title = 'Add <span class="text-gold">' + left + ' more</span> ' + item + (left > 1 ? ' perfumes' : ' perfume') + ', get 3 for <span class="text-gold">' + combo.price + '</span>';
        sub = 'And win a chance at ' + combo.prize;
      } else {
        title = (count > 3 ? (count / 3) + ' combos unlocked' : 'Combo unlocked') + ': 3 for <span class="text-gold">' + combo.price + '</span>';
        sub = 'You&rsquo;re in the lucky draw for ' + combo.prize;
      }
      var bars = '';
      for (var i = 0; i < 3; i++) bars += '<span class="h-1 flex-1 rounded-full ' + (i < filled ? 'bg-gold' : 'bg-white/20') + '"></span>';
      var cta = left || count === 0
        ? '<a href="' + combo.url + '" class="shrink-0 self-center text-[11px] font-semibold uppercase tracking-[0.14em] text-gold underline-offset-2 hover:underline">Shop</a>'
        : '<span class="shrink-0 self-center text-lg text-gold" aria-hidden="true">&#10003;</span>';
      return '<div class="mb-4 flex gap-3 rounded-card bg-ink p-3 text-left text-white">' +
        '<img src="' + combo.img + '" alt="" width="485" height="274" class="h-12 w-20 shrink-0 self-center object-contain">' +
        '<div class="min-w-0 flex-1"><p class="text-sm font-medium leading-snug">' + title + '</p>' +
        '<p class="mt-0.5 text-[11px] leading-snug text-white/60">' + sub + '</p>' +
        '<div class="mt-2 flex gap-1">' + bars + '</div></div>' + cta + '</div>';
    }

    function fillCombo(count) {
      if (!combo) return;
      $$('[data-combo-nudge]').forEach(function (el) { el.innerHTML = renderCombo(count); });
    }

    function render(cart) {
      var content = $('[data-cart-content]');
      if (content) content.innerHTML = cart.item_count === 0 ? renderEmpty() : renderContents(cart);
      updateCount(cart.item_count);
      if (combo) fillCombo(comboCount(cart));
    }
    if (combo) fillCombo(combo.count);

    function refresh(open) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); if (open) openCart(); return cart; });
    }

    function change(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); return cart; });
    }

    // Delegated clicks
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeCart(); return; }
      var minus = e.target.closest('[data-cart-minus]');
      var plus = e.target.closest('[data-cart-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      if (minus || plus || remove) {
        var btn = minus || plus || remove;
        var row = btn.closest('[data-cart-item]');
        var key = btn.getAttribute('data-key');
        var qtyEl = row && row.querySelector('[data-cart-qty]');
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var next = remove ? 0 : (plus ? current + 1 : current - 1);
        change(key, next);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    // Add-to-cart from any product form
    $$('[data-product-form] form, form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart], [type="submit"]');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (r) { return r.json(); })
          .then(function () { return refresh(true); })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.removeAttribute('disabled'); });
      });
    });

    window.__openCart = openCart;
    // Programmatic add (used by Quick Add on product cards)
    window.__addToCart = function (variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { return refresh(true); });
    };
  }

  /* ============================ Quick Add (PLP cards) ============================ */
  function initQuickAdd() {
    if (window.__quickAddBound) return;
    window.__quickAddBound = true;
    function closePanels(except) {
      $$('[data-qa-panel]').forEach(function (p) { if (p !== except) p.classList.add('hidden'); });
      $$('[data-qa-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-qa-toggle]');
      if (toggle) {
        e.preventDefault();
        var panel = toggle.parentNode.querySelector('[data-qa-panel]');
        var isOpen = panel && !panel.classList.contains('hidden');
        closePanels();
        if (panel && !isOpen) { panel.classList.remove('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
        return;
      }
      var add = e.target.closest('[data-qa-add]');
      if (add) {
        e.preventDefault();
        if (add.hasAttribute('disabled')) return;
        var id = add.getAttribute('data-qa-add');
        add.setAttribute('disabled', 'disabled');
        var prev = add.textContent; add.textContent = 'Adding…';
        Promise.resolve(window.__addToCart && window.__addToCart(id))
          .then(function () { closePanels(); })
          .catch(function () {})
          .then(function () { add.removeAttribute('disabled'); add.textContent = prev; });
        return;
      }
      if (!e.target.closest('[data-quick-add]')) closePanels();
    });
  }

  /* ============================ Recently viewed ============================ */
  function initRecentlyViewed() {
    var KEY = 'ha_recently_viewed';
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {} }

    // Save on the PDP
    var save = $('[data-rv-save]');
    var currentHandle = null;
    if (save) {
      currentHandle = save.getAttribute('data-handle');
      var item = {
        handle: currentHandle,
        title: save.getAttribute('data-title'),
        url: save.getAttribute('data-url'),
        image: save.getAttribute('data-image'),
        price: save.getAttribute('data-price')
      };
      var list = read().filter(function (p) { return p.handle !== item.handle; });
      list.unshift(item);
      write(list);
    }

    // Render on any page that has the grid
    var section = $('[data-recently-viewed]');
    var grid = $('[data-rv-grid]');
    if (!section || !grid) return;
    var max = parseInt(section.getAttribute('data-rv-max'), 10) || 8;
    var items = read().filter(function (p) { return p.handle && p.handle !== currentHandle; }).slice(0, max);
    if (!items.length) return;
    grid.innerHTML = items.map(function (p) {
      var img = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy" class="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105">'
        : '';
      return '<a href="' + escapeHtml(p.url) + '" class="group block">' +
        '<div class="relative aspect-square overflow-hidden rounded-2xl bg-white">' + img + '</div>' +
        '<div class="px-0.5 pt-4">' +
        '<h3 class="text-[15px] font-medium text-ink">' + escapeHtml(p.title || '') + '</h3>' +
        (p.price ? '<p class="mt-2 font-geo text-base tracking-wide text-amber">' + escapeHtml(p.price) + '</p>' : '') +
        '</div></a>';
    }).join('');
    section.removeAttribute('hidden');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ============================ Hero carousel ============================ */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var slides = $$('[data-hero-slide]', hero);
      var dots = $$('[data-hero-dot]', hero);
      var status = $('[data-hero-status]', hero);
      if (slides.length < 2) return;
      var i = 0, timer;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('hidden', idx !== i); });
        dots.forEach(function (d, idx) {
          var on = idx === i;
          d.classList.toggle('w-8', on); d.classList.toggle('bg-gold', on);
          d.classList.toggle('w-2', !on); d.classList.toggle('bg-white/40', !on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (status) status.textContent = 'Slide ' + (i + 1) + ' of ' + slides.length;
      }
      function next() { show(i + 1); }
      function prev() { show(i - 1); }
      function restart() { clearInterval(timer); timer = setInterval(next, 6000); }
      hero.addEventListener('click', function (e) {
        if (e.target.closest('[data-hero-next]')) { next(); restart(); }
        else if (e.target.closest('[data-hero-prev]')) { prev(); restart(); }
        else {
          var dot = e.target.closest('[data-hero-dot]');
          if (dot) { show(dots.indexOf(dot)); restart(); }
        }
      });
      show(0); restart();
    });
  }

  /* ============================ Horizontal scrollers ============================ */
  function initScrollers() {
    $$('[data-scroller-root]').forEach(function (rootEl) {
      var track = $('[data-scroller]', rootEl);
      if (!track) return;
      function amount() { return Math.max(track.clientWidth * 0.8, 280); }
      rootEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-scroll-next]')) track.scrollBy({ left: amount(), behavior: 'smooth' });
        else if (e.target.closest('[data-scroll-prev]')) track.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
    });
  }

  /* ============================ Accordions ============================ */
  function initAccordions() {
    function setPanel(trigger, open) {
      var panel = trigger.nextElementSibling;
      if (!panel) return;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        panel.style.height = 'auto';
        var h = panel.scrollHeight;
        panel.style.height = '0px';
        requestAnimationFrame(function () { panel.style.height = h + 'px'; });
        panel.addEventListener('transitionend', function te() { panel.style.height = 'auto'; panel.removeEventListener('transitionend', te); });
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () { panel.style.height = '0px'; });
      }
      var plus = trigger.querySelector('.icon');
      if (plus) plus.style.transform = open ? 'rotate(45deg)' : '';
    }
    $$('[data-accordion]').forEach(function (acc) {
      $$('[data-accordion-trigger]', acc).forEach(function (trigger) {
        var panel = trigger.nextElementSibling;
        if (panel) { panel.style.overflow = 'hidden'; panel.style.transition = 'height .35s ease'; }
        setPanel(trigger, trigger.getAttribute('aria-expanded') === 'true');
        trigger.addEventListener('click', function () {
          setPanel(trigger, trigger.getAttribute('aria-expanded') !== 'true');
        });
      });
    });
  }

  /* ============================ Tabs ============================ */
  function initTabs() {
    $$('[data-tabs]').forEach(function (group) {
      var tabs = $$('[data-tab]', group);
      var panels = $$('[data-tab-panel]', group);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab-target');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) { p.classList.toggle('hidden', p.getAttribute('data-tab-panel') !== target); });
        });
      });
    });
  }

  /* ============================ Product form (PDP) ============================ */
  function initProductForm() {
    var rootEl = $('[data-product-form]');
    if (!rootEl) return;
    var moneyFormat = (function () { var c = $('[data-cart-root]'); return c ? c.getAttribute('data-money-format') : '${{amount}}'; })();
    var priceEl = $('[data-product-price]', rootEl);
    var compareEl = $('[data-product-compare]', rootEl);
    var compareWrap = $('[data-product-compare-wrap]', rootEl);
    var offEl = $('[data-product-off]', rootEl);
    var idInput = $('[data-variant-id-input]', rootEl);
    var titleEl = $('[data-product-variant-title]', rootEl);
    // PDP prices show a standalone dirham glyph, so the amount spans carry the number only.
    var AMT = '{{amount}}';

    $$('[data-variant-option]', rootEl).forEach(function (input) {
      input.addEventListener('change', function () {
        var price = parseInt(input.getAttribute('data-price'), 10);
        var compare = parseInt(input.getAttribute('data-compare'), 10) || 0;
        if (idInput) idInput.value = input.getAttribute('data-variant-id');
        if (priceEl) priceEl.textContent = formatMoney(price, AMT);
        if (titleEl) {
          var lbl = input.getAttribute('data-variant-label') || (input.closest('label') && input.closest('label').textContent.trim());
          if (lbl) titleEl.textContent = lbl;
        }
        if (compareEl && offEl) {
          if (compare > price) {
            compareEl.textContent = formatMoney(compare, AMT);
            if (compareWrap) compareWrap.classList.remove('hidden');
            offEl.textContent = Math.round((1 - price / compare) * 100) + '% Off'; offEl.classList.remove('hidden');
          } else {
            if (compareWrap) compareWrap.classList.add('hidden');
            offEl.classList.add('hidden');
          }
        }
      });
    });

    // Quantity stepper
    var qty = $('[data-qty-input]', rootEl);
    rootEl.addEventListener('click', function (e) {
      if (!qty) return;
      if (e.target.closest('[data-qty-plus]')) qty.value = (parseInt(qty.value, 10) || 1) + 1;
      else if (e.target.closest('[data-qty-minus]')) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    });

    // Gallery thumbnails
    var gallery = $('[data-gallery]', rootEl);
    if (gallery) {
      var slides = $$('[data-gallery-slide]', gallery); // present only for rich-media (video/3D) galleries
      var mainImg = function () { var m = $('[data-gallery-main]', gallery); return m && m.querySelector('img'); };
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (slides.length) {
            var idx = thumb.getAttribute('data-gallery-index');
            slides.forEach(function (s) {
              var active = s.getAttribute('data-gallery-index') === idx;
              s.classList.toggle('hidden', !active);
              if (!active) { var v = s.querySelector('video'); if (v && v.pause) v.pause(); }
            });
          } else {
            var timg = thumb.querySelector('img');
            var mimg = mainImg();
            if (timg && mimg) {
              var src = timg.currentSrc || timg.src;
              mimg.removeAttribute('srcset');
              mimg.src = src.replace(/(_\d+x\d*|[?&]width=\d+)/i, function (m) {
                return m.indexOf('width=') > -1 ? m.replace(/\d+/, '1200') : '_1200x';
              });
            }
          }
          $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('border-gold'); t.classList.add('border-transparent', 'opacity-70'); });
          thumb.classList.add('border-gold'); thumb.classList.remove('border-transparent', 'opacity-70');
        });
      });
    }
  }

  /* ============================ Wishlist (localStorage) ============================ */
  function initWishlist() {
    var KEY = 'habib-wishlist';
    function get() {
      try {
        var v = JSON.parse(localStorage.getItem(KEY)) || [];
        // migrate legacy array of id strings → objects
        return v.map(function (x) { return typeof x === 'string' ? { id: x } : x; });
      } catch (e) { return []; }
    }
    function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    function has(list, id) { return list.some(function (x) { return String(x.id) === String(id); }); }

    function paint() {
      var list = get();
      $$('[data-wishlist-toggle]').forEach(function (btn) {
        var on = has(list, btn.getAttribute('data-product-id'));
        var icon = btn.querySelector('.icon');
        if (icon) icon.style.fill = on ? 'currentColor' : 'none';
        btn.classList.toggle('text-[#b4453a]', on);
      });
      // Header heart count badge
      $$('[data-wishlist-count]').forEach(function (b) {
        b.textContent = list.length;
        b.classList.toggle('hidden', list.length === 0);
        b.classList.toggle('grid', list.length > 0);
      });
    }

    function card(p) {
      var img = p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" class="absolute inset-0 h-full w-full object-cover">' : '';
      return '<div class="group relative" data-wishlist-card data-id="' + p.id + '">' +
        '<a href="' + (p.url || '#') + '" class="block">' +
        '<div class="relative overflow-hidden rounded-2xl bg-[#f1ede6]"><div class="relative aspect-square overflow-hidden rounded-2xl">' + img + '</div></div>' +
        '<div class="px-0.5 pt-4"><h3 class="text-[15px] font-medium text-ink">' + escapeHtml(p.title || '') + '</h3>' +
        (p.price ? '<p class="mt-2 font-geo text-base tracking-wide text-amber">' + escapeHtml(p.price) + '</p>' : '') +
        '</div></a>' +
        '<button type="button" data-wishlist-remove data-id="' + p.id + '" aria-label="Remove from wishlist" class="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full bg-white text-ink shadow-sm transition hover:text-[#b4453a]">' +
        '<svg class="icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>';
    }

    function renderPage() {
      var grid = $('[data-wishlist-grid]');
      if (!grid) return;
      var list = get().filter(function (p) { return p.title || p.handle; });
      var empty = $('[data-wishlist-empty]');
      if (!list.length) {
        grid.innerHTML = '';
        if (empty) empty.classList.remove('hidden');
        grid.classList.add('hidden');
        return;
      }
      if (empty) empty.classList.add('hidden');
      grid.classList.remove('hidden');
      grid.innerHTML = list.map(card).join('');
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        var id = toggle.getAttribute('data-product-id');
        var list = get();
        if (has(list, id)) {
          list = list.filter(function (x) { return String(x.id) !== String(id); });
        } else {
          list.push({
            id: id,
            handle: toggle.getAttribute('data-product-handle') || '',
            title: toggle.getAttribute('data-product-title') || '',
            image: toggle.getAttribute('data-product-image') || '',
            url: toggle.getAttribute('data-product-url') || '',
            price: toggle.getAttribute('data-wishlist-price') || ''
          });
        }
        set(list); paint(); renderPage();
        return;
      }
      var remove = e.target.closest('[data-wishlist-remove]');
      if (remove) {
        var rid = remove.getAttribute('data-id');
        set(get().filter(function (x) { return String(x.id) !== String(rid); }));
        paint(); renderPage();
      }
    });

    paint();
    renderPage();
  }

  /* ============================ Load more (collection) ============================ */
  function initLoadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-url');
      if (!url || btn.dataset.loading) return;
      btn.dataset.loading = '1';
      btn.textContent = 'Loading…';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var srcGrid = doc.querySelector('[data-product-grid]');
        var grid = $('[data-product-grid]');
        if (srcGrid && grid) {
          Array.prototype.slice.call(srcGrid.children).forEach(function (k) {
            k.classList.add('is-visible');
            grid.appendChild(k);
          });
          if (window.__applyCollectionFilters) window.__applyCollectionFilters();
        }
        var nextBtn = doc.querySelector('[data-load-more]');
        if (nextBtn) {
          btn.setAttribute('data-url', nextBtn.getAttribute('data-url'));
          btn.setAttribute('href', nextBtn.getAttribute('href') || '#');
        } else {
          var wrap = btn.closest('[data-load-more-wrap]');
          (wrap || btn).remove();
        }
        delete btn.dataset.loading;
        btn.textContent = 'Load More';
      }).catch(function () { window.location.href = url; });
    });
  }

  /* ============================ Collection filters (AJAX, no reload) ============================ */
  function initCollectionFilters() {
    if (window.__collFiltersBound) return;
    window.__collFiltersBound = true;

    // Mobile filter bottom-sheet, query fresh each time so it survives AJAX swaps.
    function sheetEl() { return $('[data-filter-sheet]'); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) {
        var sh = sheetEl(); if (!sh) return;
        sh.classList.remove('hidden');
        var pn = $('[data-filter-panel]', sh);
        requestAnimationFrame(function () { if (pn) pn.classList.remove('translate-y-full'); });
        document.body.classList.add('no-scroll');
      } else if (e.target.closest('[data-filter-close]')) {
        var sh2 = sheetEl(); if (!sh2) return;
        var pn2 = $('[data-filter-panel]', sh2);
        if (pn2) pn2.classList.add('translate-y-full');
        document.body.classList.remove('no-scroll');
        setTimeout(function () { sh2.classList.add('hidden'); }, 300);
      }
    });

    if (!$('[data-collection-root]')) return;
    window.__ajaxFilters = true;

    function busy(on) {
      var root = $('[data-collection-root]');
      if (!root) return;
      root.style.opacity = on ? '0.55' : '';
      root.style.transition = 'opacity .2s';
    }

    // Family/gender pills use path-based tag filtering on the virtual "all"
    // collection, where collection.current_tags isn't reliably re-populated by
    // the Section Rendering API. Drive the active highlight from the URL so the
    // selected category/gender always lights up (parity with availability pills).
    var CATS = ['fresh', 'floral', 'woody', 'oriental', 'citrus'];
    var GENDERS = ['him', 'her', 'unisex'];
    function activeFromPath(pathname) {
      var after = (pathname.split('/collections/')[1] || '');
      var seg = (after.split('/')[1] || '').toLowerCase();
      var res = { cat: '', gender: '' };
      seg.split('+').forEach(function (part) {
        if (CATS.indexOf(part) > -1) res.cat = part;
        if (GENDERS.indexOf(part) > -1) res.gender = part;
      });
      return res;
    }
    function syncActiveFilters(pathname) {
      var root = $('[data-collection-root]');
      if (!root) return;
      var a = activeFromPath(pathname);
      $$('[data-cat]', root).forEach(function (el) {
        el.classList.toggle('is-active', (el.getAttribute('data-cat') || '').toLowerCase() === a.cat);
      });
      $$('[data-gender]', root).forEach(function (el) {
        el.classList.toggle('is-active', (el.getAttribute('data-gender') || '').toLowerCase() === a.gender);
      });
    }

    function swap(html, url, push) {
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-collection-root]');
      var current = $('[data-collection-root]');
      if (!next || !current) { window.location.href = url; return; }
      current.innerHTML = next.innerHTML;
      document.body.classList.remove('no-scroll');
      $$('.reveal', current).forEach(function (el) { el.classList.add('is-visible'); });
      syncActiveFilters((url || location.pathname).split('?')[0]);
      if (push) { try { history.pushState({ af: 1 }, '', url); } catch (e) {} }
      var top = current.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    }

    function navigate(url, push) {
      var u;
      try { u = new URL(url, location.origin); } catch (e) { window.location.href = url; return; }
      var root = $('[data-collection-root]');
      var fetchU = new URL(u.toString());
      fetchU.searchParams.set('section_id', root ? root.getAttribute('data-section-id') : 'main');
      busy(true);
      fetch(fetchU.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) { swap(html, u.pathname + u.search, push); })
        .catch(function () { window.location.href = url; })
        .then(function () { busy(false); });
    }

    // Filter / facet / applied / clear links
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-collection-root] a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (a.hasAttribute('data-load-more')) return;       // pagination has its own handler
      if (href.indexOf('/products/') > -1) return;         // product cards
      if (href.indexOf('/collections/') === -1) return;    // only collection/filter URLs
      if (e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      e.preventDefault();
      navigate(href, true);
    });

    function formUrl(form) {
      var base = new URL(form.getAttribute('action') || location.href, location.origin);
      base.search = new URLSearchParams(new FormData(form)).toString();
      return base.pathname + base.search;
    }

    // Facet checkboxes / sort select (instant)
    document.addEventListener('change', function (e) {
      var t = e.target;
      var form = t.closest && t.closest('[data-collection-root] form');
      if (!form) return;
      var type = (t.getAttribute('type') || '').toLowerCase();
      if (t.tagName === 'SELECT' || type === 'checkbox' || type === 'radio') {
        navigate(formUrl(form), true);
      }
    });

    // Facet forms (price apply, etc.)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-collection-root] form');
      if (!form) return;
      e.preventDefault();
      navigate(formUrl(form), true);
    });

    window.addEventListener('popstate', function () { navigate(location.href, false); });

    // Correct the active category/gender highlight on first load too.
    syncActiveFilters(location.pathname);
  }

  /* ============================ Search overlay ============================ */
  function initSearch() {
    var overlay = $('[data-search-overlay]');
    if (!overlay) return;
    var panel = $('[data-search-panel]', overlay);
    var backdrop = $('[data-search-close]', overlay);
    var input = $('[data-search-input]', overlay);
    var results = $('[data-search-results]', overlay);
    var timer;

    function open() {
      overlay.classList.remove('hidden');
      requestAnimationFrame(function () { panel.classList.remove('-translate-y-full'); if (backdrop) backdrop.classList.add('opacity-100'); });
      document.body.classList.add('no-scroll');
      setTimeout(function () { if (input) input.focus(); }, 120);
    }
    function close() {
      panel.classList.add('-translate-y-full');
      if (backdrop) backdrop.classList.remove('opacity-100');
      document.body.classList.remove('no-scroll');
      setTimeout(function () { overlay.classList.add('hidden'); }, 300);
    }

    function render(data, term) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        results.innerHTML = '<p class="py-6 text-sm text-taupe">No matches for “' + escapeHtml(term) + '”. Try a note or family.</p>';
        return;
      }
      var rows = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var imgTag = img ? '<span class="h-12 w-12 shrink-0 overflow-hidden rounded bg-ink"><img src="' + img + '" alt="" class="h-full w-full object-cover"></span>' : '';
        return '<a href="' + p.url + '" class="flex items-center gap-3 rounded-lg px-2 py-2 transition hover:bg-black/[0.04]">' + imgTag +
          '<span class="min-w-0"><span class="block truncate text-sm font-medium text-ink">' + escapeHtml(p.title) + '</span>' +
          (p.price ? '<span class="block font-geo text-sm text-amber">' + escapeHtml(p.price) + '</span>' : '') + '</span></a>';
      }).join('');
      results.innerHTML = '<div class="divide-y divide-black/5">' + rows + '</div>' +
        '<a href="/search?type=product&q=' + encodeURIComponent(term) + '" class="mt-3 block border-t border-black/10 pt-3 text-sm font-semibold text-ink hover:text-gold">See all results for “' + escapeHtml(term) + '” →</a>';
    }

    function query(term) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(d, term); })
        .catch(function () { results.innerHTML = ''; });
    }

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);
        if (term.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function () { query(term); }, 250);
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-search-close]') || e.target === backdrop) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.classList.contains('hidden')) close(); });
  }

  /* ============================ Init ============================ */
  function init() {
    initLoadMore();
    initCollectionFilters();
    initSearch();
    initReveals();
    initMobileMenu();
    initCart();
    initHero();
    initScrollers();
    initAccordions();
    initTabs();
    initProductForm();
    initWishlist();
    initWaForms();
    initQuickAdd();
    initRecentlyViewed();
    initOfferPopup();
  }
  // Contact/wholesale form submit → opens WhatsApp AND emails a branded PDF (via the enquiry service)
  /* ============================ Offer popup ============================ */
  // Once per browser session, shortly after load (snippets/offer-popup.liquid).
  function initOfferPopup() {
    var popup = $('[data-offer-popup]');
    if (!popup) return;
    var KEY = 'offerPopupSeen';
    try { if (sessionStorage.getItem(KEY)) return; } catch (err) {}

    function open() {
      popup.classList.remove('hidden');
      popup.classList.add('flex');
      requestAnimationFrame(function () { popup.classList.add('opacity-100'); popup.classList.remove('opacity-0'); });
      document.body.classList.add('no-scroll');
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
    }
    function close() {
      popup.classList.add('opacity-0'); popup.classList.remove('opacity-100');
      document.body.classList.remove('no-scroll');
      setTimeout(function () { popup.classList.add('hidden'); popup.classList.remove('flex'); }, 300);
    }
    popup.addEventListener('click', function (e) { if (e.target.closest('[data-offer-popup-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.classList.contains('hidden')) close(); });
    setTimeout(open, 1500);
  }

  function initWaForms() {
    $$('[data-wa-form]').forEach(function (form) {
      if (form.dataset.waBound) return;
      form.dataset.waBound = '1';
      // Phone fields: allow only digits (and a single leading +); clear the error as the user edits
      $$('input[type="tel"]', form).forEach(function (ph) {
        ph.addEventListener('input', function () {
          var start = ph.selectionStart;
          var before = ph.value;
          var clean = before.replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
          if (clean !== before) {
            ph.value = clean;
            var np = Math.max(0, start - (before.length - clean.length));
            try { ph.setSelectionRange(np, np); } catch (e) {}
          }
          ph.setCustomValidity('');
        });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // Phone validation: 7–15 digits (ignoring +, spaces, dashes, brackets)
        $$('input[type="tel"]', form).forEach(function (ph) {
          var digits = (ph.value || '').replace(/[^\d]/g, '');
          var msg = '';
          if (!(ph.value || '').trim()) {
            if (ph.hasAttribute('required')) msg = 'Please enter your phone number.';
          } else if (digits.length < 7 || digits.length > 15) {
            msg = 'Enter a valid phone number (7–15 digits), e.g. +971 50 123 4567.';
          }
          ph.setCustomValidity(msg);
        });
        if (form.checkValidity && !form.checkValidity()) { form.reportValidity(); return; }
        var fields = [];
        $$('[data-wa-label]', form).forEach(function (el) {
          var val = (el.value || '').trim();
          if (val) fields.push({ label: el.getAttribute('data-wa-label'), value: val });
        });
        // 1) WhatsApp text (if a number is configured)
        var num = (form.getAttribute('data-wa-number') || '').replace(/[^0-9]/g, '');
        if (num) {
          var lines = [form.getAttribute('data-wa-intro') || 'New enquiry', ''].concat(
            fields.map(function (f) { return f.label + ': ' + f.value; }));
          window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(lines.join('\n')), '_blank');
        }
        // 2) Email a branded PDF (if the enquiry service endpoint is configured)
        var endpoint = form.getAttribute('data-wa-endpoint');
        if (endpoint) {
          fetch(endpoint, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ formType: form.getAttribute('data-wa-type') || 'contact', fields: fields }),
          }).catch(function () {});
        }
        var done = form.querySelector('[data-wa-done]');
        if (done) done.classList.remove('hidden');
        form.reset();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run on Theme Editor section load
  document.addEventListener('shopify:section:load', init);
})();
